import React from 'react';
import { BOX_IMAGE, CHECKOUT_URL, PRODUCT_NAME, PURCHASE_ANCHOR } from '../data/content';
interface BoxImageProps {
  className?: string;
  target?: 'purchase' | 'checkout';
}
export function BoxImage({
  className = '',
  target = 'purchase'
}: BoxImageProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block ${className}`} data-id="element-26" data-mp="2rv8hzorypufr">
      <img src={BOX_IMAGE} alt={`${PRODUCT_NAME} complete 6-in-1 pool & spa troubleshooting and repair system box set`} className="mx-auto w-full drop-shadow-[0_18px_30px_rgba(0,199,232,0.25)]" data-id="element-27" data-mp="1z4qfaov5hv2v" />
    </a>;
}